var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrinticon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.820312,
    y: 0.707031,
    width: 27.5859,
    height: 27.5859,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6621_45310",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6621_45310",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAClElEQVR4nO3dPWtTYRTA8Udx0UlBN11ER50UnBrpc1oEBQcpvuY56eLXaPHLiC+7IkJxcbHWPid+g06CYkWnLJXbTZBCktuek5v/D85+7/nf26RJk6YEAAAAAAAAAFEsD4YXstZ1KfY8F3vZpZHmnLSu9x7X82kWLBa7KsV2RW2v01PspwzqlRRdLvbefVl6VFHquxRdVvvjvig9qqm/U3T+S7IjnRSd94KEIAQJzfuKFe4QgoTmfcUKd8i/lga2Mk+TAAAA0BVra3vHF3X7QVZ7m9W+eT/3lxmZ/V0Ve5P7w/sp7R1rJcat1a1zWe2D98nJrE+pG72Hm2eninHn6eYpKfbZ/WS0G5O1frqx8vHkxEGk1GfeJyFdm2JrE8Xo9TZO5FJ/uJ+Adm3q92a3YwfJg+F1/4O3bk7fro0fpF/vuh+4dnOa3Y4dpHkl0/vApaMz0avEBDGCSICrlzskwIKEIP5LEYL4L0KCDA/q6h+BIOq/eIKo/7IJov4LJoj6L5Ug6r9Igqj/8jobpPnAZJpRufmwJ0HiIEgwBAmGIMEQJBiCBEOQYAgSDEGCIUgwBAmGIMEQJBiCBEOQYEIEybp9j/dDDidIs9s0rqzDmwQ5pDuk1IU0rp5+OS3FRrxjmNoNUmx0+5GdSZOQYq8JkloNkrW+mCjGfpDB1uWs9RfvqVs7QYrt5lW7mKaR+yZtRJn7P3Iotrs02F5MbVh+8vWSqL2a5jFlboMUGzU/pqa+M/6neTBqniEc9A1r8xZk6aBvnCt1oXly5Hrw8xYkRUeQYAgSDEGCIUgwBAmGIMEQJBiCBHPAywg7M/uf2dR2OveLYVcnRee9ICEIQULzvmKFO4QgoXlfscIdAgAAAAAAUlv+AtjYAiZxVJfoAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinticon);
export default __webpack_public_path__ + "static/media/printicon.edbf4ff298011e5a569b206145347313.svg";
export { ForwardRef as ReactComponent };